export const bannerData = [
  {
    title: "Atul gaming is officially sponsored by Thanos eShop",
    src: "./banners/banner1.png",
    link: "./banners/banner2.jpg",
  },
  {
    title: "Thanos eShop mega offer running",
    src: "./banners/banner2.jpg",
    link: "./gsdgsdgsdgsg.jpg",
  },
  {
    title: "Thanos eShop mega offer running",
    src: "./banners/banner2.jpg",
    link: "./gsdgsdgsdgsg.jpg",
  },
  {
    title: "Thanos eShop mega offer running",
    src: "./banners/banner2.jpg",
    link: "./gsdgsdgsdgsg.jpg",
  },
  {
    title: "Thanos eShop mega offer running",
    src: "./banners/banner2.jpg",
    link: "./gsdgsdgsdgsg.jpg",
  },
  {
    title: "Thanos eShop mega offer running",
    src: "./banners/banner2.jpg",
    link: "./gsdgsdgsdgsg.jpg",
  },
  {
    title: "Thanos eShop mega offer running",
    src: "./banners/banner2.jpg",
    link: "./gsdgsdgsdgsg.jpg",
  },
  {
    title: "Thanos eShop mega offer running",
    src: "./banners/banner2.jpg",
    link: "./gsdgsdgsdgsg.jpg",
  },
  {
    title:
      "Thanos eShop officially sponsored with Atul gamming, mr snake & thoughts with vibe",
    src: "./banners/banner3.jpg",
    link: "./sdgsdgsdg.jpg",
  },
  {
    title: "mr. Snake is now officially sponsored by thanos eshop",
    src: "./banners/banner4.jpeg",
    link: "",
  },
];
